export default __webpack_public_path__ + "static/media/stainless-steel.8623f20d.png";